export const RWG_COOKIE = 'rwgCookie';
export const ReferrerPartners = {
    GOOGLE: 'google',
    APPLE: 'apple',
};
